var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricetagOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.252 2.344h-6.001a.706.706 0 00-.498.205L2.756 14.546a1.409 1.409 0 000 1.987l5.713 5.713a1.409 1.409 0 001.987 0l11.992-11.992a.706.706 0 00.205-.498V3.75a1.4 1.4 0 00-1.401-1.406z",
    stroke: "#FF7D6B",
    strokeWidth: 1.563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.813a1.563 1.563 0 110-3.126 1.563 1.563 0 010 3.125z",
    fill: "#FF7D6B"
  })));
}
export default SvgPricetagOutline;